import classnames from 'classnames';
import React, { FC } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import './TaskExpandCard.scss';

export interface TaskExpandCardProps {
    title: string;
    expanded?: boolean;
    description: string;
    taskIsDone?: boolean;
    deadlineHasPassed?: boolean;
    deadlineIsToday?: boolean;
    labels?: React.ReactNode;
    tasks?: React.ReactNode;
    attachments?: React.ReactNode;
}

const TaskExpandCard: FC<TaskExpandCardProps> = ({
    expanded = false,
    deadlineIsToday,
    description,
    title,
    taskIsDone = false,
    deadlineHasPassed,
    labels,
    tasks,
    attachments,
}) => {
    return (
        <details
            className={classnames('task-expand-card', {
                'task-expand-card--complete': taskIsDone || deadlineHasPassed,
                'task-expand-card--deadline-is-today': deadlineIsToday,
            })}
            open={expanded}
        >
            <summary className={classnames('task-expand-card__summary')}>
                <div className="task-expand-card__summary-wrapper">
                    {labels}
                    <span className="task-expand-card__summary-wrapper--bold-text">{title}</span>
                    <span>{description}</span>
                </div>
                <Icon type={IconTypes.PIL_DROPDOWN_NED_24} />
            </summary>
            <div
                className={classnames('task-expand-card__expanded-body', {
                    'task-expand-card__expanded-body--completed': taskIsDone || deadlineHasPassed,
                    'task-expand-card__expanded-body--deadline-is-today': deadlineIsToday,
                })}
            >
                {tasks}
                {attachments}
            </div>
        </details>
    );
};

export default TaskExpandCard;
